import ApiService from '~/util/apiService';

export const optIntoSMSNotifications = (phoneNumber: string) => {
  const body = {
    phoneNumber: phoneNumber.replace(/[^0-9]/g, ''),
    optedIn: true,
  };
  return ApiService.put(`/web-marketplace-api/v1/manage/user/phone-number`, body);
};
